<template>
  <ExternalList
      headline="New Leads"
      endpoint="/api/v2/project-leads"
      :default-page-size="10"
      :endpoint-filters="{project_id: project.id, status:'new'}"
      :headlines="headlines"
      :show-list-actions="false"
      :show-checkboxes="false"
      :show-buttons="false"
      :show-pagination="false"
      :page-size-options="null"
      :can-destroy="() => true"
  >
    <template v-slot:default="{ row: projectLead }">
      <td class="table__ellipsis">
        <router-link :to="'/companies/' + projectLead.attributes.company_id">
          {{ projectLead.attributes.company_name }}
        </router-link>
      </td>
    </template>

    <template #headline-right>
      <router-link to="project-leads" class="btn btn-white btn-sm" style="margin-top: 4px;">
        <i class="fa fa-search"></i> Show all
      </router-link>
    </template>
  </ExternalList>
</template>

<script>
import ExternalList from '../../../../Panels/Lists/External'

export default {
  components: { ExternalList},

  props: {
    project: {
      required: true
    }
  },

  data() {
    return {
      editing: null
    }
  },

  computed: {
    headlines() {
      return [
        {width: 24, text: 'Company'},
      ]
    },
  }
}
</script>
